import { useMemo } from "react";
import { isObject } from "lodash";

import { useParsedFieldProps } from "./useParsedFieldProps";
import { useCheckboxesSchema } from "./useCheckboxesSchema";
import { CHECKBOXES_SELECT } from "../SchemaTypes";
import Field from "../Field";
import CheckboxesSelectInput from "../../Input/CheckboxesSelectInput";

const CheckboxesSelectField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { defaultValues, required, parent } = props;

  const defaultValue = useMemo(() => {
    const value = defaultValues[0];

    return isObject(value) ? value : { value };
  }, [defaultValues]);

  const schema = useCheckboxesSchema({
    type: CHECKBOXES_SELECT,
    singleOptionSelection: true,
    required,
    parent
  });

  return (
    <Field {...fieldProps} schema={schema}>
      <CheckboxesSelectInput {...inputProps} defaultValue={defaultValue} />
    </Field>
  );
};

export default CheckboxesSelectField;
